import { render } from "./resetPw.vue?vue&type=template&id=4eb3a512"
import script from "./resetPw.vue?vue&type=script&lang=js"
export * from "./resetPw.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\loong\\develop\\project\\tianyuan\\ty-maintain-web\\ty-maintain-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__